import store from "@/store";
export default [
    {
        path: "/admin/employees",
        name: "employee",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/employee/index.vue")
    },
    {
        path: "/admin/employees/create",
        name: "employee-create",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/employee/create.vue")
    },
    {
        path: "/admin/employees/:id/edit",
        name: "employee-edit",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/employee/edit.vue")
    },
    {
        path: "/admin/employees/:id/show",
        name: "employee-show",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/employee/show.vue"),
        beforeEnter: async (to, from, next) => {
            await store.dispatch("humanResource/employee/find", to.params.id);
            next();
        }
    }
];
